export const DEFAULT_DURATION = 5000
export const STATUS = {
  ERROR: 'error',
  SUCCESS: 'success',
}
export const COLOR_GREEN = 'green'
export const COLOR_RED = 'red'
